import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AccountService } from '@app/core/services/account.service';

@Injectable()
export class AccountGuard implements CanActivate {
  public test;
    constructor(private accountSvc: AccountService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // When user log out, we must clear the account server state.
        // When user navigate to builder first time, there is no token so he will be routed to login page.
        if ((route.data && route.data['allowAnonymous']) || (route.parent.data && route.parent.data['allowAnonymous'])) {
          return true;
        } else {
          return this.accountSvc.isAuthenticated(state.url);
        }
    }
}
